import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page Not Found - SugarGoo Spreadsheet";
    const metaRobots = document.createElement("meta");
    metaRobots.name = "robots";
    metaRobots.content = "noindex, nofollow";
    document.head.appendChild(metaRobots);
    return () => {
      const el = document.querySelector('meta[name="robots"]');
      if (el) el.remove();
    };
  }, []);

  return (
    <main className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <p className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-50 select-none pointer-events-none z-0">
        404
      </p>
      <div className="relative z-10">
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-6">
          This page has not been generated
        </h1>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">
          Tell me more about this page, so I can generate it
        </p>
        <Link
          to="/"
          className="mt-8 inline-block px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors"
        >
          Back to Homepage
        </Link>
      </div>
    </main>
  );
}